import { render, staticRenderFns } from "./UsersTable.vue?vue&type=template&id=01705014&scoped=true"
import script from "./UsersTable.vue?vue&type=script&lang=ts"
export * from "./UsersTable.vue?vue&type=script&lang=ts"
import style0 from "./UsersTable.vue?vue&type=style&index=0&id=01705014&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01705014",
  null
  
)

export default component.exports